<mat-expansion-panel [expanded]="isopen() || dataisopen()">
  <mat-expansion-panel-header>
    <mat-panel-title class="item-title">
      <span class="d-inline-block w-100 fs-body-md lh-sm">{{ datatitle() }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-content />
</mat-expansion-panel>
